"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var RecordingMetaStatus;
(function (RecordingMetaStatus) {
    RecordingMetaStatus["SCHEDULED"] = "SCHEDULED";
    RecordingMetaStatus["ACTIVE"] = "ACTIVE";
    RecordingMetaStatus["PARTIAL"] = "PARTIAL";
    RecordingMetaStatus["DONE"] = "DONE";
    RecordingMetaStatus["DONE_ERROR"] = "DONE_ERROR";
})(RecordingMetaStatus = exports.RecordingMetaStatus || (exports.RecordingMetaStatus = {}));
//# sourceMappingURL=RecordingMetaStatus.js.map